// extracted by mini-css-extract-plugin
export default {"wrap":"NUpRS","highlight":"bRL48"};